import type { OffsetPageQueryDTO } from "@/shared/contracts/base";
import { config } from "@/shared/lib/config";
import { fetcher } from "@/shared/lib/fetcher";
import type { Department, OrgChartOverview } from "../../domain/types";

const baseUrl = `${config.apiUrl}/org-chart`;

export const orgChartApi = {
  async getOverview(
    params: { departmentId?: string; includeInactive?: boolean } = {},
  ) {
    const searchParams = new URLSearchParams();
    if (params.departmentId) {
      searchParams.set("departmentId", params.departmentId);
    }
    if (params.includeInactive) {
      searchParams.set("includeInactive", "true");
    }

    const url = `${baseUrl}/overview?${searchParams.toString()}`;
    return fetcher.get<OrgChartOverview>(url);
  },

  async listDepartments(query: Partial<OffsetPageQueryDTO> = {}) {
    const params = new URLSearchParams();
    if (query.limit) params.set("limit", String(query.limit));
    if (query.offset) params.set("offset", String(query.offset));
    if (query.sort) params.set("sort", JSON.stringify(query.sort));
    if (query.filters) params.set("filters", JSON.stringify(query.filters));

    const url = `${baseUrl}/departments?${params.toString()}`;
    return fetcher.get<Department[]>(url);
  },

  async listPositions(query: Partial<OffsetPageQueryDTO> = {}) {
    const params = new URLSearchParams();
    if (query.limit) params.set("limit", String(query.limit));
    if (query.offset) params.set("offset", String(query.offset));
    if (query.sort) params.set("sort", JSON.stringify(query.sort));
    if (query.filters) params.set("filters", JSON.stringify(query.filters));

    const url = `${baseUrl}/positions?${params.toString()}`;
    return fetcher.get(url);
  },

  async updateNodesPosition(
    positions: Array<{ nodeId: string; x: number; y: number }>,
  ) {
    const url = `${baseUrl}/nodes/positions`;
    return fetcher.put<{ success: boolean; updated: number }>(url, {
      positions,
    });
  },
};
